const handleResponse = (response) => {
  if (response?.status === 'fulfilled') return response?.value || null;
  return { error: response?.reason?.response?.status || null };
};

export default handleResponse;
